import React from 'react';
import IVRSchemeSetting from './index';

const IVRSchemePage = () => {
    return (
        <div style={{ padding: '20px', width: '100%' }}>
            <IVRSchemeSetting />
        </div>
    );
};

export default IVRSchemePage;
